import React from 'react';

const boxCheapest = (props) => (
    <div className={`u-block mr-auto u-phoneHide u-size24x24`}>{props.children}</div>
);

export default boxCheapest;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Desktop/Tuple/BoxCheapest/BoxCheapest.js